import Vue from 'vue'
import router from '~/router'
import store from '~/store'
import i18n from '~/plugins/i18n'
import App from '~/components/App'

import '~/config'
import '~/plugins'
import '~/components'
import '~/mixins'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	i18n,
	store,
	router,
	...App
})



// WEBPACK FOOTER //
// ./resources/js/app.js